import { ChartType, CURRENCY_LOCALE_MAPPING, DEFAULT_SUFFIX_META } from '../config/chart.config.js';
import dayjs from './../external_lib/dayjs/dayjs.min.js';
import advancedFormat from './../external_lib/dayjs/plugin/advancedFormat.js';
dayjs.extend(advancedFormat);
// get x-axis readable timestamps for line and bar charts based on duration presets
var getReadableTimestamp = function (timestamp, durationPreset) {
  var period = '';
  if (durationPreset == 'THIS_YEAR') {
    var startOfYear = dayjs().startOf('year');
    var diff = dayjs().diff(startOfYear, 'day') + 1;
    if (diff < 31) {
      period = 'day';
    } else {
      period = 'month';
    }
  } else if (durationPreset == 'LAST_90_DAYS' || durationPreset == 'LAST_30_DAYS' || durationPreset == 'THIS_MONTH') {
    period = '90day';
  } else if (durationPreset == 'TODAY' || durationPreset == 'YESTERDAY') {
    period = 'hour';
  } else if (durationPreset == 'THIS_WEEK') {
    var startOfDay = dayjs().startOf('d');
    var diff = dayjs().diff(startOfDay, 'd');
    if (diff < 2) {
      period = 'hour';
    } else {
      period = 'day';
    }
  } else if (durationPreset === null || durationPreset === void 0 ? void 0 : durationPreset.includes(',')) {
    var dates = durationPreset.split(',');
    var diff = dayjs(dates[1]).diff(dayjs(dates[0]), 'd');
    if (diff < 2) {
      period = 'hour';
    } else {
      period = 'day';
    }
  } else {
    period = 'day';
  }
  return timeStampToDurPreset(timestamp, period, true);
};
var timeStampToDurPreset = function (timestamp, preset, v2) {
  if (v2 === void 0) {
    v2 = false;
  }
  switch (preset) {
    case 'hour':
      return dayjs(timestamp).format('h A');
    case '90day':
      return dayjs(timestamp).format('Do MMM');
    case 'day':
      return dayjs(timestamp).format("Do MMM".concat(!v2 ? ' hh:mm A' : ''));
    case 'month':
      return dayjs(timestamp).format("MMM".concat(v2 ? " 'YY" : ''));
    default:
      return formatDate(timestamp);
  }
};
var formatDate = function (timestamp, format) {
  if (format === void 0) {
    format = 'DD MMM, YYYY - hh:mm A';
  }
  if (timestamp) {
    return dayjs(timestamp).format(format);
  }
  return '--';
};
var formatLabel = function (label) {
  if (typeof label === 'string') {
    return label.charAt(0).toUpperCase() + label.slice(1);
  }
  return label;
};
var renderCenterMetricValue = function (props, languageCode, currency, properties) {
  var total = 0;
  props.dataWithArc.forEach(function (datum) {
    total += Math.round(datum.value);
  });
  return commifyNumbers(total, languageCode, currency, properties);
};
var getNavigatorLanguage = function (currency) {
  return currency && CURRENCY_LOCALE_MAPPING[currency] ? CURRENCY_LOCALE_MAPPING[currency].languageCode : navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language || 'en-US';
};
var commifyNumbers = function (num, currency, languageCode, properties) {
  if (currency === void 0) {
    currency = '';
  }
  if (languageCode === void 0) {
    languageCode = '';
  }
  if (properties === void 0) {
    properties = {};
  }
  // languageCode parameter is for overridinig the biz/default formatting
  languageCode = !languageCode ? getNavigatorLanguage(currency) : languageCode;
  if (num === '--') {
    return num;
  } else if (num == 0) {
    return '0';
  } else if (num) {
    try {
      return new Intl.NumberFormat(languageCode, properties || {}).format(Number(num));
    } catch (err) {
      console.log(err);
      return num;
    }
  } else {
    return '--';
  }
};
var getSuffixMetaInfo = function (currency) {
  return currency && CURRENCY_LOCALE_MAPPING[currency] ? CURRENCY_LOCALE_MAPPING[currency].suffixMeta : DEFAULT_SUFFIX_META;
};
var getSuffixedNumber = function (num, currency, suffixMeta) {
  if (currency === void 0) {
    currency = '';
  }
  if (!isNaN(num)) {
    // suffixMeta parameter is for overridinig the biz/default suffix config
    suffixMeta = !suffixMeta ? getSuffixMetaInfo(currency) : suffixMeta;
    if (num < suffixMeta[0].base) {
      return commifyNumbers(num);
    }
    for (var i = suffixMeta.length - 1; i >= 0; i--) {
      if (num >= suffixMeta[i].base) {
        var commified = commifyNumbers(Number(num / suffixMeta[i].base).toFixed(1));
        return commified + suffixMeta[i].suffix;
      }
    }
  } else {
    return '--';
  }
};
var getChartTooltipInfo = function (props, chart, type) {
  var _a, _b, _c, _d;
  if (chart === void 0) {
    chart = null;
  }
  switch (chart) {
    case ChartType.PIE:
      var datum = props.datum;
      return {
        index: null,
        label: datum.label || datum.id,
        value: datum.value,
        highlight: {
          background: datum.color
        }
      };
    case ChartType.LINE:
      var point_1 = props.point,
        yScaleStacked = props.yScaleStacked,
        lineWidth = props.lineWidth,
        data = props.data,
        dashedLineIds_1 = props.dashedLineIds;
      var tooltipInfo = {
        // check for compare value in 'point.data.z' to show in tooltip
        index: point_1.data.z ? point_1.data.z : point_1.data.x,
        label: point_1.serieId,
        value: yScaleStacked ? point_1.data.yStacked : point_1.data.y,
        highlight: {
          background: point_1.serieColor,
          width: lineWidth + 1
        },
        direction: '',
        compareIndex: null,
        compareLabel: null,
        compareValue: null
      };
      if (props.showCompareInTooltip) {
        var isDashedLinePoint_1 = dashedLineIds_1.includes(point_1 === null || point_1 === void 0 ? void 0 : point_1.serieId);
        var compareLine = data.find(function (line) {
          return isDashedLinePoint_1 ? !dashedLineIds_1.includes(line === null || line === void 0 ? void 0 : line.id) : dashedLineIds_1.includes(line === null || line === void 0 ? void 0 : line.id);
        });
        var comparePoint = compareLine ? compareLine.data.find(function (pt) {
          return pt.x === point_1.data.x;
        }) : undefined;
        tooltipInfo.index = isDashedLinePoint_1 ? (comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.z) || (comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.x) : ((_a = point_1 === null || point_1 === void 0 ? void 0 : point_1.data) === null || _a === void 0 ? void 0 : _a.z) || ((_b = point_1 === null || point_1 === void 0 ? void 0 : point_1.data) === null || _b === void 0 ? void 0 : _b.x);
        tooltipInfo.label = point_1.serieId;
        tooltipInfo.value = isDashedLinePoint_1 ? comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.y : yScaleStacked ? point_1.data.yStacked : point_1.data.y;
        tooltipInfo.compareIndex = isDashedLinePoint_1 ? ((_c = point_1 === null || point_1 === void 0 ? void 0 : point_1.data) === null || _c === void 0 ? void 0 : _c.z) || ((_d = point_1 === null || point_1 === void 0 ? void 0 : point_1.data) === null || _d === void 0 ? void 0 : _d.x) : (comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.z) || (comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.x);
        tooltipInfo.compareLabel = point_1.serieId;
        tooltipInfo.compareValue = isDashedLinePoint_1 ? yScaleStacked ? point_1.data.yStacked : point_1.data.y : comparePoint === null || comparePoint === void 0 ? void 0 : comparePoint.y;
      }
      return tooltipInfo;
    case ChartType.SANKEY:
      var node = props.node,
        link = props.link,
        showPercentValue = props.showPercentValue;
      if (type === 'node' && showPercentValue) {
        var links = node.targetLinks.length > 0 ? node.targetLinks : node.sourceLinks;
        node.count = links.reduce(function (acc, curr) {
          acc + curr.count;
        });
      }
      return {
        index: null,
        label: type === 'node' ? node.id : "".concat(link.source.id, " \u2014 ").concat(link.target.id),
        value: showPercentValue ? type === 'node' ? node.count : link.count : type === 'node' ? node.value : link.value,
        highlight: type === 'node' ? {
          background: node.color
        } : {
          background: link.source.color
        },
        direction: type === 'link' ? 'right' : '',
        rightHighlight: type === 'link' ? {
          background: link.target.color
        } : {}
      };
    default:
      return null;
  }
};
var getReadableDateFilter = function (compare, appliedDateFilter) {
  var _a, _b;
  if (compare === void 0) {
    compare = false;
  }
  var readableDateFilter = '';
  var currTimestamp = ((_a = appliedDateFilter === null || appliedDateFilter === void 0 ? void 0 : appliedDateFilter.current) === null || _a === void 0 ? void 0 : _a.dateFilter) || '';
  var compTimestamp = ((_b = appliedDateFilter === null || appliedDateFilter === void 0 ? void 0 : appliedDateFilter.compare) === null || _b === void 0 ? void 0 : _b.dateFilter) || '';
  var presetMap = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    THIS_WEEK: 'This Week',
    THIS_MONTH: 'This Month',
    THIS_YEAR: 'This Year',
    LAST_7_DAYS: 'Last 7D',
    LAST_15_DAYS: 'Last 15D',
    LAST_30_DAYS: 'Last 30D',
    LAST_90_DAYS: 'Last 90D'
  };
  var comparePresetMap = {
    TODAY: 'Yesterday',
    YESTERDAY: 'Day Before Yesterday',
    THIS_WEEK: 'Last Week',
    THIS_MONTH: 'Last Month',
    THIS_YEAR: 'Last Year',
    LAST_7_DAYS: 'Prev 7D',
    LAST_15_DAYS: 'Prev 15D',
    LAST_30_DAYS: 'Prev 30D',
    LAST_90_DAYS: 'Prev 90D'
  };
  if (compare) {
    if (comparePresetMap[currTimestamp]) {
      readableDateFilter = comparePresetMap[currTimestamp];
    } else {
      var dates = compTimestamp.split(',');
      readableDateFilter = formatDate(dates[0], 'DD MMM, YYYY') + ' - ' + formatDate(dates[1], 'DD MMM, YYYY');
    }
  } else {
    if (presetMap[currTimestamp]) {
      readableDateFilter = presetMap[currTimestamp];
    } else {
      var dates = currTimestamp.split(',');
      readableDateFilter = formatDate(dates[0], 'DD MMM, YYYY') + ' - ' + formatDate(dates[1], 'DD MMM, YYYY');
    }
  }
  return readableDateFilter;
};
export { commifyNumbers, formatDate, formatLabel, getChartTooltipInfo, getReadableDateFilter, getReadableTimestamp, getSuffixedNumber, renderCenterMetricValue, timeStampToDurPreset };
//# sourceMappingURL=chart.util.js.map
